import { tempoApi } from '@/lib/api/tempoApi';
import type { TeamRole } from '@/lib/api/types/teamRoles';

const getTeamRoles = async (): Promise<TeamRole[]> => {
  return await tempoApi().get('api/v1/capacity/team-roles').json<TeamRole[]>();
};

const updateTeamRole = async (id: number, name: string, isCritical: boolean): Promise<TeamRole> => {
  return await tempoApi()
    .patch(`api/v1/capacity/team-roles/${id}`, { json: { name, isCritical } })
    .json<TeamRole>();
};

const searchTeamRoles = async (query: string): Promise<TeamRole[]> => {
  return await tempoApi()
    .get('api/v1/capacity/team-roles/search', { searchParams: { query } })
    .json<TeamRole[]>();
};

const bulkCreateTeamRoles = async (
  teamRoles: Array<{ name: string; isCritical?: boolean }>,
): Promise<TeamRole[]> => {
  return await tempoApi()
    .post('api/v1/capacity/team-roles/bulk', {
      json: {
        roles: teamRoles,
      },
    })
    .json<TeamRole[]>();
};

const deleteTeamRole = async (id: number): Promise<void> => {
  return await tempoApi().delete(`api/v1/capacity/team-roles/${id}`).json();
};

export const TeamRolesApi = {
  getTeamRoles,
  searchTeamRoles,
  bulkCreateTeamRoles,
  updateTeamRole,
  deleteTeamRole,
} as const;
